import { PlansUnion } from '@/stores/types';
import rg from '@/lib/ga4';
import { logrocketInit } from '../config/logRocket';

const callWindowFN = (fnName: string, ...args: any[]) => {
	if (import.meta.env.DEV) return;
	if (typeof window !== 'undefined' && (window as any)[fnName]) {
		(window as any)[fnName](...args);
	}
};

export class VendorAnalytics {
	static initAll() {
		VendorAnalytics.LogRocketInit();
		VendorAnalytics.GoogleAnalyticsInit();
	}

	static LogRocketInit() {
		if (import.meta.env.VITE_LOGROCKET_KEY) {
			logrocketInit();
		}
	}

	static GoogleAnalyticsInit() {
		if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
			rg.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID);
		}
	}

	static onRegistrationComplete() {
		callWindowFN('gtag', 'event', 'userSignUp');
	}

	static onPurchaseComplete({ price, ...data }: { price: number; plan: PlansUnion }) {
		callWindowFN('gtag', 'event', 'newSubscriber', {
			conversionValue: price,
			currency: 'NOK',
			...data,
		});
	}
}
